<template>
  <div class="min-h-screen flex items-center justify-center bg-slate-950 font-outfit p-6 relative overflow-hidden">
    <!-- Architectural Blueprint Background -->
    <div class="absolute inset-0 pointer-events-none opacity-20" aria-hidden="true">
      <div class="blueprint-grid absolute inset-0"></div>
      <div class="absolute top-0 right-0 w-1/2 h-1/2 bg-blue-500/20 blur-[150px] rounded-full"></div>
      <div class="absolute bottom-0 left-0 w-1/2 h-1/2 bg-indigo-500/20 blur-[150px] rounded-full"></div>
    </div>

    <!-- Background Blueprint Decorations -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden select-none" aria-hidden="true">
       <div class="absolute bottom-10 right-10 text-[10px] text-blue-500/30 font-mono text-right">
          <div>© {{ new Date().getFullYear() }} CODIFYO SYSTEMS</div>
          <div>MOTEUR DE SCRAPPING ACTIF</div>
       </div>
       <Compass class="absolute top-[20%] right-[10%] w-32 h-32 text-blue-500/5 rotate-12" />
       <Ruler class="absolute bottom-[20%] left-[5%] w-64 h-12 text-blue-500/5 -rotate-12" />
    </div>

    <!-- Generic Auth Modal -->
    <AuthModal 
      app-name="Plans" 
      app-key="plans" 
      subtitle="Module Architectural"
      theme-color="blue"
      success-route="plans_home"
    >
      <template #logo>
        <Map class="w-8 h-8" />
      </template>
      <template #title-suffix>
        <span class="text-blue-500 opacity-80">Hub</span>
      </template>
    </AuthModal>
  </div>
</template>

<script setup>
import { Compass, Ruler, Map } from 'lucide-vue-next'
import AuthModal from '../Auth/AuthModal.vue'
</script>

<style>
.blueprint-grid {
  background-image: 
    linear-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(59, 130, 246, 0.1) 1px, transparent 1px);
  background-size: 30px 30px;
}
</style>
